import React, { useRef } from "react";
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDInput from "components/MDInput";

function PinInput({ value, onChange, disabled }) {
  const pinRefs = useRef();

  const setPinIndex = (e, index = 0) => {
    const oldPin = value + "     ";
    const left = 6 - index;
    const targetValue = e.target.value.replace(/[^0-9]/g, " ").trim() || " ";
    const newPart = targetValue.length > left ? targetValue.substring(0, left) : targetValue;
    const newPin =
      oldPin.substring(0, index) + newPart + oldPin.substring(index + newPart.length, 6);

    onChange({ currentTarget: { value: newPin } });

    const newFocus = index + newPart.trim().length;
    if (pinRefs[newFocus]) {
      pinRefs[newFocus].focus();
      pinRefs[newFocus].select();
    }
  };

  const splitPin = value.split("");

  return (
    <Grid container spacing={1} mb={3}>
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <Grid item xs={2} key={i}>
          <MDInput
            type="text"
            name="1"
            inputRef={(c) => (pinRefs[i] = c)}
            value={(splitPin[i] || "").trim()}
            onChange={(e) => setPinIndex(e, i)}
            inputProps={{ inputMode: "numeric" }}
            fullWidth
            disabled={disabled}
          />
        </Grid>
      ))}
    </Grid>
  );
}

PinInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default PinInput;
